"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var Button_1 = __importDefault(require("../Button"));

var Toolbar_1 = __importDefault(require("../Toolbar"));

var Typography_1 = __importDefault(require("../Typography"));

var SvgIcon_1 = __importDefault(require("../SvgIcon"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var ExpandMore = React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}));

var styles = function styles(_ref) {
  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      spacing = _ref.spacing;
  return createStyles_1.createStyles({
    root: {
      minHeight: 0,
      borderRadius: '4px',
      flexWrap: 'wrap'
    },
    title: {
      flexBasis: '100%',
      display: 'flex',
      alignItems: 'center',
      padding: spacing(1) + "px " + spacing(1) + "px " + spacing(1) + "px " + spacing(2) + "px",
      lineHeight: '1.33'
    },
    titleSpan: {
      paddingRight: spacing(2)
    },
    titleSecondary: {
      fontStyle: 'italic',
      textTransform: 'initial',
      letterSpacing: 0,
      opacity: 0.87
    },
    titleGroup: {
      display: 'flex',
      flexGrow: 1,
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: spacing(1),
      '& + svg': {
        marginLeft: spacing(2)
      }
    },
    titleCollapse: {
      padding: 0,
      '& > button': {
        display: 'flex',
        width: '100%',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        letterSpacing: 'inherit',
        color: 'inherit',
        textTransform: 'inherit',
        textAlign: 'left',
        paddingLeft: spacing(2),
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&:focus': {
          boxShadow: 'none',
          '& > span > svg:last-child': {
            boxShadow: '0 0 0 2px currentColor'
          }
        }
      }
    },
    titleOpen: {
      borderRadius: '4px 4px 0 0',
      '& button': {
        borderRadius: '4px 4px 0 0'
      }
    },
    headerSquare: {
      borderRadius: '0 !important',
      '& button, ': {
        borderRadius: '0 !important'
      }
    },
    icon: {
      fontSize: '1.25em',
      marginRight: spacing(1),
      marginLeft: "-" + spacing(0.5) + "px",
      display: 'inline-block',
      lineHeight: 0
    },
    collapseIcon: {
      marginLeft: 'auto',
      borderRadius: '50%',
      transform: 'rotate(0)',
      transition: 'all 180ms ease-in-out'
    },
    collapseIconOpen: {
      transform: 'rotate(180deg)'
    },
    expandedHeader: {
      flexBasis: '100%',
      backgroundColor: 'inherit',
      padding: spacing(1) + "px " + spacing(2) + "px"
    }
  });
};

var PanelHeader = React.forwardRef(function (props, ref) {
  var _clsx_1$default, _clsx_1$default2, _clsx_1$default3;

  var _a = props,
      children = _a.children,
      classes = _a.classes,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? false : _a$icon,
      iconLabel = _a.iconLabel,
      title = _a.title,
      secondaryTitle = _a.secondaryTitle,
      _a$titleComponent = _a.titleComponent,
      titleComponent = _a$titleComponent === void 0 ? 'h4' : _a$titleComponent,
      _a$titleVariant = _a.titleVariant,
      titleVariant = _a$titleVariant === void 0 ? 'button' : _a$titleVariant,
      _a$enableCollapse = _a.enableCollapse,
      enableCollapse = _a$enableCollapse === void 0 ? false : _a$enableCollapse,
      handlePanelToggle = _a.handlePanelToggle,
      panelExpanded = _a.panelExpanded,
      square = _a.square,
      toolbarProps = __rest(_a, ["children", "classes", "icon", "iconLabel", "title", "secondaryTitle", "titleComponent", "titleVariant", "enableCollapse", "handlePanelToggle", "panelExpanded", "square"]);

  var className = clsx_1.default(classes.root, (_clsx_1$default = {}, _clsx_1$default[classes.titleOpen] = panelExpanded, _clsx_1$default[classes.headerSquare] = square, _clsx_1$default), props.className);
  var collapseIconClasses = clsx_1.default(classes.collapseIcon, (_clsx_1$default2 = {}, _clsx_1$default2[classes.collapseIconOpen] = panelExpanded, _clsx_1$default2));
  var titleClasses = clsx_1.default(classes.title, (_clsx_1$default3 = {}, _clsx_1$default3[classes.titleOpen] = panelExpanded, _clsx_1$default3[classes.titleCollapse] = enableCollapse, _clsx_1$default3[classes.headerSquare] = square, _clsx_1$default3));
  var titlePrimary = React.createElement("span", {
    className: classes.titleSpan
  }, title);
  var titleSecondary = React.createElement("span", {
    className: classes.titleSecondary
  }, secondaryTitle);
  var titleBody = React.createElement(React.Fragment, null, icon && React.createElement("div", {
    className: classes.icon,
    "aria-label": iconLabel
  }, icon), !secondaryTitle && titlePrimary, secondaryTitle && React.createElement("div", {
    className: classes.titleGroup
  }, titlePrimary, titleSecondary));
  var collapseTitleBody = React.createElement(Button_1.default, {
    variant: "text",
    color: "inherit",
    disableRipple: true,
    onClick: handlePanelToggle,
    "aria-expanded": panelExpanded
  }, titleBody, React.createElement(SvgIcon_1.default, {
    "aria-label": "Show more",
    className: collapseIconClasses
  }, ExpandMore));
  return React.createElement(Toolbar_1.default, Object.assign({}, toolbarProps, {
    disableGutters: true,
    variant: "dense",
    className: className
  }), React.createElement(Typography_1.default, {
    component: titleComponent,
    variant: titleVariant,
    className: titleClasses
  }, enableCollapse && collapseTitleBody, !enableCollapse && titleBody), children && React.createElement("div", {
    className: classes.expandedHeader
  }, children));
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiPanelHeader'
})(PanelHeader);